import { Form } from "react-bootstrap";
import styled from "styled-components";

export const VehicleDanfeFormWrapper = styled(Form)`
  padding: 0 60px 0 0;
`;
